'use strict';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var debug = require('debug')('leoric');
var SqlString = require('sqlstring');
var Logger = /** @class */ (function () {
    function Logger(opts) {
        if (typeof opts === 'function')
            opts = { logQuery: opts };
        Object.assign(this, { hideKeys: [] }, opts);
    }
    Logger.prototype.format = function (query, values, opts) {
        if (opts === void 0) { opts = {}; }
        var command = opts.command, sets = opts.sets;
        if (['insert', 'upsert', 'update'].includes(command) && sets) {
            var hideKeys_1 = this.hideKeys;
            var keys_1 = Object.keys(sets);
            values = values.map(function (entry, i) {
                // INSERT ... ON DUPLICATE UPDATE ...
                var index = command === 'upsert' ? i % keys_1.length : i;
                return hideKeys_1.includes(keys_1[index]) ? '***' : entry;
            });
        }
        return SqlString.format(query.sql || query, values);
    };
    Logger.prototype.tryLogQuery = function () {
        try {
            this.logQuery.apply(this, __spreadArray([], __read(arguments), false));
        }
        catch (error) {
            console.error(error);
        }
    };
    Logger.prototype.logQuery = function (sql, duration, opts) {
        debug('[query] [%s] %s', duration, sql);
    };
    Logger.prototype.logQueryError = function (sql, err, duration, opts) {
        // err is thrown by default hence not logged here
        console.error('[query] [%s] %s', duration, sql);
    };
    Logger.prototype.logMigration = function (name) {
        debug('[migration] %s', name);
    };
    return Logger;
}());
module.exports = Logger;
//# sourceMappingURL=logger.js.map